import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {InactivateReasonModel} from "../../models/InactivateReason.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LookupsServiceService {
  private lookupsUrl = `${environment.apiUrl}/common`;
  constructor(private http: HttpClient) { }

  getInactivateReasons(): Observable<InactivateReasonModel[]> {
    return this.http.get<any>(`${this.lookupsUrl}/inactivateReasons`);
  }
}
